import {CopyOutlined, EditOutlined} from "@ant-design/icons";

// import InfoBlock from "./InfoBlock";

import FileItem from "./FileItem";

import styles from "./user-info.module.scss";

const UserInfo = ({email, phone, city, country, address, job_descr_client, job_descr_delegate, files}) => {
    const about = job_descr_delegate || job_descr_client;

    const elements = files.map((file, index) => <FileItem key={index} {...file} />)

    return (
        <div className={styles.wrapper}>
            <div className={styles.heading}>
                <h5>Client Information</h5>
                {/*<EditOutlined style={{color: "#A9B2CC"}} />*/}
            </div>
            <div className={styles.infoWrapper}>
                <div className={styles.infoEmail}>
                    <p className={styles.title}>Email <CopyOutlined className={styles.icon} /></p>
                    <p className={styles.content}>{email}</p>
                </div>
                <div className={styles.infoPhone}>
                    <p className={styles.title}>Phone number <CopyOutlined className={styles.icon} /></p>
                    <p className={styles.content}>{phone}</p>
                </div>
                <div className={styles.infoCity}>
                    <p className={styles.title}>City <CopyOutlined className={styles.icon} /></p>
                    <p className={styles.content}>{city}</p>
                </div>
                <div className={styles.infoCountry}>
                    <p className={styles.title}>Country <CopyOutlined className={styles.icon} /></p>
                    <p className={styles.content}>{country}</p>
                </div>
                <div className={styles.infoAddress}>
                    <p className={styles.title}>Address <CopyOutlined className={styles.icon} /></p>
                    <p className={styles.content}>{address}</p>
                </div>
                <div className={styles.infoAbout}>
                    <p className={styles.title}>About <CopyOutlined className={styles.icon} /></p>
                    <p className={styles.content}>{about}</p>
                </div>
            </div>
            <div className={styles.heading}>
                <h5>Documents</h5>
            </div>
            {elements}
        </div>
    )
}

export default UserInfo;
